import { render, staticRenderFns } from "./x-button.vue?vue&type=template&id=ee9c1d00&scoped=true&"
import script from "./x-button.vue?vue&type=script&lang=js&"
export * from "./x-button.vue?vue&type=script&lang=js&"
import style0 from "./x-button.vue?vue&type=style&index=0&id=ee9c1d00&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9c1d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ee9c1d00', component.options)
    } else {
      api.reload('ee9c1d00', component.options)
    }
    module.hot.accept("./x-button.vue?vue&type=template&id=ee9c1d00&scoped=true&", function () {
      api.rerender('ee9c1d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-button.vue"
export default component.exports